import React from 'react'

import './rolling-number.scss'

const DIGIT_COUNT_PER_ROTATION = 10
const ROTATION_COUNT = 4
const TOTAL_REEL_STEPS = DIGIT_COUNT_PER_ROTATION * ROTATION_COUNT
const REEL_DURATIONS = [ 5, 6, 5.4 ]

export type DemoRollingDirection = 'down' | 'up'

type Props = {
  direction: DemoRollingDirection
  value?: number | string
}

const getReelDigits = (initialDigit: number, direction: DemoRollingDirection) => {
  if (direction === 'up') {
    return Array.from(
      { length: TOTAL_REEL_STEPS + 1 },
      (_, index) => (initialDigit + index) % DIGIT_COUNT_PER_ROTATION,
    )
  }

  return Array.from(
    { length: TOTAL_REEL_STEPS + 1 },
    (_, index) => (
      initialDigit - (TOTAL_REEL_STEPS - index) + TOTAL_REEL_STEPS
    ) % DIGIT_COUNT_PER_ROTATION,
  )
}

const isDigit = (character: string) => /^\d$/.test(character)

const DemoRollingNumber = ({ direction, value }: Props) => {
  let reelIndex = 0

  return (
    <span
      aria-hidden='true'
      className='demo-rolling-number'
    >
      {Array.from(String(value ?? '')).map((character, characterIndex) => {
        if (!isDigit(character)) {
          return (
            <span
              className='demo-rolling-number__separator'
              key={`${character}-${characterIndex}`}
            >
              {character}
            </span>
          )
        }

        const currentReelIndex = reelIndex
        reelIndex += 1

        return (
          <span
            className='demo-rolling-number__window'
            key={characterIndex}
          >
            <span
              className={`demo-rolling-number__reel demo-rolling-number__reel_${direction}`}
              style={{
                animationDuration: `${REEL_DURATIONS[currentReelIndex % REEL_DURATIONS.length]}s`,
              }}
            >
              {getReelDigits(Number(character), direction).map((digit, digitIndex) => (
                <span
                  className='demo-rolling-number__digit'
                  key={`${digitIndex}-${digit}`}
                >
                  {digit}
                </span>
              ))}
            </span>
          </span>
        )
      })}
    </span>
  )
}

export default DemoRollingNumber

